<script lang="ts">
  // Editor section "Financieel": hourly rate, the resulting amount and billable.
  import '../../messages/entries';
  import { Field, MoneyInput, Toggle } from '../../ui';
  import { t } from '../../i18n.svelte';
  import { formatMoney } from '../../format';
  import EditorSection from './EditorSection.svelte';
  import type { EntryForm } from './form.svelte';

  let { form }: { form: EntryForm } = $props();
</script>

<EditorSection title={t('entries.section_money')}>
  <div class="grid-2 money">
    <Field label={t('field.rate')} for={form.id('rate')} error={form.show('rate')}>
      <MoneyInput id={form.id('rate')} bind:value={form.rate} suffix={t('common.per_hour')} placeholder={form.rateLoading ? '…' : '0,00'} onchange={() => (form.rateTouched = true)} />
    </Field>
    <div class="amount">
      <span class="eyebrow">{t('field.amount')}</span>
      <span class="value tabular" class:strike={!form.billable}>{formatMoney(form.amount)}</span>
    </div>
  </div>
  <Toggle checked={form.billable} label={t('field.billable')} description={t('entries.billable_hint')} onchange={(on) => form.setBillable(on)} />
</EditorSection>

<style>
  .money { align-items: start; }
  .amount { display: flex; flex-direction: column; justify-content: flex-end; gap: var(--space-1_5); padding-top: var(--space-0_5); }
  .value { display: flex; align-items: center; height: var(--control-h); font-size: var(--text-xl); font-weight: var(--weight-bold); }
  .strike { color: var(--text-3); text-decoration: line-through; }
</style>
